/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  window.theme = window.theme || {};
  window.theme.motion = {
    prefersReduced: function() {
      return reducedMotion.matches;
    },
    scrollBehavior: function() {
      return reducedMotion.matches ? 'auto' : 'smooth';
    }
  };

  function normalizeScrollOptions(options) {
    if (!reducedMotion.matches || !options || typeof options !== 'object' || options.behavior !== 'smooth') {
      return options;
    }

    return Object.assign({}, options, { behavior: 'auto' });
  }

  function patchScrollMethod(target, method) {
    if (!target || typeof target[method] !== 'function') return;

    const original = target[method];
    target[method] = function() {
      const args = Array.prototype.slice.call(arguments);
      args[0] = normalizeScrollOptions(args[0]);
      return original.apply(this, args);
    };
  }

  patchScrollMethod(window, 'scroll');
  patchScrollMethod(window, 'scrollTo');
  patchScrollMethod(window, 'scrollBy');
  patchScrollMethod(Element.prototype, 'scroll');
  patchScrollMethod(Element.prototype, 'scrollTo');
  patchScrollMethod(Element.prototype, 'scrollBy');
  patchScrollMethod(Element.prototype, 'scrollIntoView');

  function stopFlickityAutoplay() {
    const Flickity = window.themeVendor && window.themeVendor.Flickity;
    if (!Flickity || !reducedMotion.matches) return;

    document.querySelectorAll('.flickity-enabled').forEach(function(slider) {
      const instance = Flickity.data(slider);
      if (instance && typeof instance.stopPlayer === 'function') {
        instance.stopPlayer();
      }
    });
  }

  function patchFlickityAutoplay() {
    const Flickity = window.themeVendor && window.themeVendor.Flickity;
    const Player = Flickity && Flickity.Player;
    if (!Player || Player.prototype.__reducedMotionPatched) return;

    ['play', 'unpause'].forEach(function(method) {
      const original = Player.prototype[method];
      if (typeof original !== 'function') return;

      Player.prototype[method] = function() {
        if (reducedMotion.matches) {
          this.stop();
          return;
        }

        return original.apply(this, arguments);
      };
    });

    Player.prototype.__reducedMotionPatched = true;
    stopFlickityAutoplay();
  }

  patchFlickityAutoplay();
  if (typeof reducedMotion.addEventListener === 'function') {
    reducedMotion.addEventListener('change', stopFlickityAutoplay);
  } else {
    reducedMotion.addListener(stopFlickityAutoplay);
  }

  // Snappier PDP image slider. theme.js builds it with Flickity's default physics
  // (~350ms to cover 90% of a slide); this gets there in ~200ms without overshoot.
  // Sliders the theme already tunes (e.g. quick view) are left alone.
  function patchProductSliderSpeed() {
    const Flickity = window.themeVendor && window.themeVendor.Flickity;
    if (!Flickity || !Array.isArray(Flickity.createMethods) || Flickity.prototype._snappyProductSlider) return;

    Flickity.prototype._snappyProductSlider = function() {
      if (!this.element.matches('[data-product-single-media-slider]')) return;
      if (this.options.selectedAttraction !== Flickity.defaults.selectedAttraction) return;

      this.options.selectedAttraction = 0.1;
      this.options.friction = 0.6;
    };
    Flickity.createMethods.push('_snappyProductSlider');
  }

  patchProductSliderSpeed();

  // Product Video Handler
  function initProductVideo() {
    // Only initialize on product pages
    if (!document.querySelector('.template-product')) return;

    const videoWrapper = document.querySelector('[data-video-wrapper]');
    if (!videoWrapper) return;

    const placeholder = videoWrapper.querySelector('[data-video-placeholder]');
    const iframe = videoWrapper.querySelector('[data-video-iframe]');
    const trigger = videoWrapper.querySelector('[data-video-trigger]');

    if (!placeholder || !iframe || !trigger) return;

    trigger.addEventListener('click', function() {
      const iframeSrc = iframe.querySelector('iframe').dataset.src;
      iframe.querySelector('iframe').src = iframeSrc;
      placeholder.style.display = 'none';
      iframe.style.display = 'block';
    });
  }

  // Initialize on DOM content loaded
  document.addEventListener('DOMContentLoaded', function() {
    initProductVideo();
  });

  // Removes a BOGOS gift line saved by the Caveman Eats buy box check.
  // Runs on every page. Listens to cart add/change/update instead of polling.
  const giftExcludeKey = 'ceGiftExclude';
  const giftRemovedNoticeKey = 'ceGiftRemovedNotice';
  const giftExcludeTtl = 6 * 60 * 60 * 1000;
  let giftExcludeBurst = 0;
  let giftExcludeLastRemoval = 0;
  let giftPurge = null;

  function giftExcludeRule() {
    try {
      const raw = localStorage.getItem(giftExcludeKey);
      if (!raw) return null;
      const rule = JSON.parse(raw);
      const checkedAt = Number(rule && rule.checkedAt);
      const fresh = Number.isFinite(checkedAt) && Date.now() - checkedAt < giftExcludeTtl;
      if (!rule || rule.exclude !== true || !giftExcludeIds(rule).length || !fresh) {
        localStorage.removeItem(giftExcludeKey);
        localStorage.removeItem(giftRemovedNoticeKey);
        return null;
      }
      return rule;
    } catch (error) {
      return null;
    }
  }

  function giftExcludeIds(rule) {
    if (Array.isArray(rule.variantIds) && rule.variantIds.length) return rule.variantIds.map(String);
    if (rule.variantId) return [String(rule.variantId)];
    return [];
  }

  function isGiftedLine(item) {
    const props = item.properties || {};
    return Object.keys(props).some((key) => {
      const name = String(key).toLowerCase();
      const value = String(props[key] ?? '').toLowerCase();
      return name.includes('bogos') || name.includes('gifted') || value.includes('gifted');
    });
  }

  function excludedGiftLines(cart, rule) {
    return (cart.items || []).filter((item) => {
      const price = item.final_price != null ? item.final_price : item.price;
      return giftExcludeIds(rule).includes(String(item.variant_id)) && price === 0 && isGiftedLine(item);
    });
  }

  function cartRoot() {
    return (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  }

  async function fetchCart() {
    const cartResponse = await fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } });
    return cartResponse.json();
  }

  function hideGiftRemovedNote() {
    const note = document.querySelector('[data-ce-gift-removed]');
    if (!note) return;
    note.classList.remove('is-visible');
    note.hidden = true;
  }

  async function refreshCartDrawer() {
    if (typeof window.lsgRenderCart !== 'function') return fetchCart();
    try {
      const rendered = await window.lsgRenderCart();
      if (rendered && Array.isArray(rendered.items)) return rendered;
    } catch (error) {}
    return fetchCart();
  }

  function purgeExcludedGifts() {
    if (!giftPurge) giftPurge = purgeExcludedGiftsNow().finally(() => { giftPurge = null; });
    return giftPurge;
  }

  async function purgeExcludedGiftsNow() {
    const rule = giftExcludeRule();
    if (!rule) return true;

    try {
      const cart = await fetchCart();
      const gifts = excludedGiftLines(cart, rule);
      if (!gifts.length) {
        giftExcludeBurst = 0;
        const latest = await refreshCartDrawer();
        if (excludedGiftLines(latest, rule).length) {
          hideGiftRemovedNote();
          return false;
        }
        showGiftRemovedNote();
        return true;
      }

      hideGiftRemovedNote();

      const now = Date.now();
      giftExcludeBurst = now - giftExcludeLastRemoval < 2000 ? giftExcludeBurst + 1 : 1;
      if (giftExcludeBurst > 3) {
        console.log('Gift exclude paused: the gift was added back');
        return false;
      }

      const changeUrl = (window.theme && window.theme.routes && window.theme.routes.cart_change_url) || (cartRoot() + 'cart/change');
      for (const line of gifts) {
        giftExcludeLastRemoval = Date.now();
        await fetch(changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        });
        console.log('Gift exclude removed', { variantId: line.variant_id, key: line.key });
      }

      const latest = await refreshCartDrawer();
      if (excludedGiftLines(latest, rule).length) {
        hideGiftRemovedNote();
        return false;
      }

      localStorage.setItem(giftRemovedNoticeKey, String(Date.now()));
      showGiftRemovedNote();
      return true;
    } catch (error) {
      console.log('Gift exclude failed', error);
      hideGiftRemovedNote();
      return false;
    }
  }

  function scheduleGiftExclude() {
    setTimeout(purgeExcludedGifts, 300);
  }

  function allowCheckout(form) {
    const button = form.querySelector('[name="checkout"]');
    form.dataset.ceCheckoutReady = 'true';
    if (button) button.disabled = false;
    if (typeof form.requestSubmit === 'function') form.requestSubmit(button || undefined);
    else form.submit();
  }

  async function checkoutWithoutGift() {
    hideGiftRemovedNote();
    const removed = await purgeExcludedGifts();

    const rule = giftExcludeRule();
    if (!rule) return true;
    if (removed) {
      const cart = await fetchCart();
      if (!excludedGiftLines(cart, rule).length) return true;
    }

    let tookGift = false;
    for (let attempt = 0; attempt < 4; attempt++) {
      const cart = await fetchCart();
      const gifts = excludedGiftLines(cart, rule);
      if (!gifts.length) break;

      tookGift = true;
      hideGiftRemovedNote();
      const changeUrl = (window.theme && window.theme.routes && window.theme.routes.cart_change_url) || (cartRoot() + 'cart/change');
      for (const line of gifts) {
        await fetch(changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        });
      }
    }

    const latest = await refreshCartDrawer();
    if (excludedGiftLines(latest, rule).length) {
      hideGiftRemovedNote();
      return false;
    }
    if (tookGift) localStorage.setItem(giftRemovedNoticeKey, String(Date.now()));
    showGiftRemovedNote();
    return true;
  }

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form || !form.classList || !form.classList.contains('slidecart-checkout-form')) return;
    if (form.dataset.ceCheckoutReady === 'true') {
      delete form.dataset.ceCheckoutReady;
      return;
    }
    if (!giftExcludeRule()) return;

    event.preventDefault();
    event.stopPropagation();
    const button = form.querySelector('[name="checkout"]');
    if (button) button.disabled = true;

    checkoutWithoutGift().then(function (clean) {
      if (button) button.disabled = false;
      if (!clean) return;
      allowCheckout(form);
    }).catch(function () {
      if (button) button.disabled = false;
    });
  }, true);

  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ''));
  }

  const originalFetch = window.fetch;
  window.fetch = function (input) {
    const response = originalFetch.apply(this, arguments);
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    if (isCartMutation(url)) response.then(scheduleGiftExclude).catch(() => {});
    return response;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__ceCartUrl = url;
    return originalOpen.apply(this, arguments);
  };
  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('load', () => {
      if (isCartMutation(this.__ceCartUrl)) scheduleGiftExclude();
    });
    return originalSend.apply(this, arguments);
  };

  function showGiftRemovedNote() {
    const note = document.querySelector('[data-ce-gift-removed]');
    if (!note) return;
    let stamp = NaN;
    try { stamp = Number(localStorage.getItem(giftRemovedNoticeKey)); } catch (error) {}
    const rule = giftExcludeRule();
    const visible = Boolean(rule) && Number.isFinite(stamp) && Date.now() - stamp < giftExcludeTtl && note.textContent.trim() !== '';
    note.classList.toggle('is-visible', visible);
    note.hidden = !visible;
    if (!visible) {
      try { localStorage.removeItem(giftRemovedNoticeKey); } catch (error) {}
    }
  }

  document.addEventListener('theme:cart:added', scheduleGiftExclude);
  document.addEventListener('theme:cart:update', scheduleGiftExclude);
  document.addEventListener('ce:gift-exclude', scheduleGiftExclude);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleGiftExclude);
  else scheduleGiftExclude();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
